import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { callApi, CDN_URL, formatDate, getInlineLoader } from "../Helpers";

export default function ViewPublication({ uuid }) {
  const appContext = useContext(AppContext);

  const [ready, setReady] = useState(false);
  const [data, setData] = useState(null);

  async function init() {
    setReady(false);
    await Promise.all([getData()]);
    setReady(true);
  }

  async function getData() {
    await callApi("get-publication-data", { uuid }).then((response) => {
      if (response.status === 1) {
        setData(response.data);
      } else {
        appContext.tellError("Could not fetch data");
      }
    });
  }

  function getViewerSrc(file) {
    const fileUrl = CDN_URL + file;
    const lowerFile = String(file || "").toLowerCase();

    if (lowerFile.endsWith(".doc") || lowerFile.endsWith(".docx")) {
      return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`;
    }

    if (lowerFile.endsWith(".pdf")) {
      return `${fileUrl}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`;
    }

    return fileUrl;
  }

  useEffect(() => {
    init();
  }, [uuid]);

  if (ready && data) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="publication-view-shell">
              <div className="publication-view-copy">
                <div className="publication-badge mb-3">
                  <span>Publication</span>
                </div>
                <h6 className="main-section-title font-semi-bold mb-3">
                  {data.title}
                </h6>
                <div className="publication-date mb-4">
                  {data.dateCreated ? formatDate(data.dateCreated) : "Latest release"}
                </div>
                <p className="publication-description mb-0">
                  {data.description}
                </p>
              </div>

              {data.photo ? (
                <div className="publication-view-image-wrap">
                  <img
                    src={CDN_URL + data.photo}
                    alt={data.title}
                    className="publication-view-image"
                  />
                </div>
              ) : null}
            </div>
          </div>

          <div className="col-md-12 mt-4 mb-4">
            {data.file ? (
              <div className="publication-reader-shell">
                <iframe
                  title={data.title}
                  src={getViewerSrc(data.file)}
                  className="publication-reader-frame"
                />
              </div>
            ) : (
              <div className="publication-empty-reader">
                <h6 className="mNoMargin">This publication file is not available.</h6>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return <div className="container mSupportLoading">{getInlineLoader()}</div>;
}
